import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { IPost } from 'types/interfaces/ITypes'

type CacheEntry = {
  // exact shape from your axios endpoint response: data = { status, code, data: IPost[], links, meta }
  rawPageData: any
  // convenience for immediate render
  items: IPost[]
  // used to preserve hasNextPage correctness
  nextCursor?: string | number
  updatedAt: number
}

interface LikesHistoryFirstPageCacheState {
  cache: Record<string, CacheEntry>

  setFirstPage: (key: string, entry: CacheEntry) => void
  getFirstPage: (key: string) => CacheEntry | undefined
  remove: (key: string) => void
  clear: () => void
}

export const useLikesHistoryFirstPageCacheStore =
  create<LikesHistoryFirstPageCacheState>()(
    persist(
      (set, get) => ({
        cache: {},

        setFirstPage: (key, entry) =>
          set(state => ({
            cache: {
              ...state.cache,
              [key]: entry
            }
          })),

        getFirstPage: (key) => get().cache[key],

        remove: (key) => {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { [key]: _removed, ...rest } = get().cache
          set({ cache: rest })
        },

        clear: () => set({ cache: {} })
      }),
      {
        name: 'likes-history-first-page-cache',
        partialize: state => ({ cache: state.cache })
      }
    )
  )
